const toTimestampMs = (birthday: Date | number) => {
    if (birthday instanceof Date) {
        return birthday.getTime();
    }

    return birthday < 1_000_000_000_000 ? birthday * 1000 : birthday;
};

export const getAgeInMonths = (
    dob: Date | number | string | null | undefined,
    asOf?: Date,
): number | null => {
    if (dob == null) return null;

    const asOfMs = asOf?.getTime() ?? Date.now();
    const ms =
        typeof dob === "string" ? new Date(dob).getTime() : toTimestampMs(dob);
    if (!Number.isFinite(ms) || ms > asOfMs) return null;

    return (asOfMs - ms) / (1000 * 60 * 60 * 24 * 30.44);
};

export const getAgeLabelFromMonths = (
    months: number | null | undefined,
): string | null => {
    if (months == null) return null;
    if (months < 12) return "Puppy";
    if (months < 36) return "Young";
    if (months < 96) return "Adult";
    return "Senior";
};

export const getLifeStageLabel = (
    dob: Date | number | string | null | undefined,
): string | null => {
    const months = getAgeInMonths(dob);
    if (months == null) return null;
    return getAgeLabelFromMonths(Math.floor(months));
};
